import Vue from "vue";
import Router from "vue-router";
import GoalBoard from "../views/GoalBoard.vue";
import HomeBoard from "../views/HomeBoard.vue";
import Goal from "../views/Goal.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home-board",
      component: HomeBoard
    },
    {
      path: "/goals",
      name: "goal-board",
      component: GoalBoard,
      children: [
        {
          path: ":id",
          name: "goal",
          component: Goal
        }
      ]
    },
    {
      path: "/*",
      name: "fourohfour",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "fourohfour" */ "../views/FourOhFour.vue")
    }
  ]
});
